import {Controller} from "stimulus"
import $ from 'jquery';
import {set_locale} from "./localize_controller";

// FIX (2026-08-04): la sesión es :cache_store → cada set_session_var hace read-modify-write de TODA
// la sesión. Dos writes concurrentes se pisan (el último en escribir revierte claves del otro) — p. ej.
// cart_count_product y cart_object en set_var_session → el carrito perdía productos (quedaba solo 1).
// Esta cola serializa los writes HTTP: nunca hay 2 en vuelo a la vez.
let sessionWriteQueue = Promise.resolve();

export let setSessionVar = (name, value, action, is_date, save = true, increment = 0, enqueue = true) => {
    // Capturar SIEMPRE el valor actual de enable_analytics (no solo cuando name es 'enable_analytics'):
    // la acción 'clear' necesita el valor real para restaurarlo en clear_session y no perder el flag de analytics.
    let analytics_var = sessionStorage.getItem('enable_analytics') || false;

    const write = () => new Promise((resolve, reject) => {
        $.ajax({
            url: location.origin + '/config/set_session_var',
            data: {
                name: name,
                value: value,
                accion: action,
                is_date: is_date,
                increment: increment
            },
            type: 'GET',
            // FIX (2026-08-11): dataType 'json' + timeout + siempre resolver. Antes, si el
            // servidor redirigía a /offline.html (HTML) o respondía {success:false}, la promesa
            // nunca resolvía y la cola de writes se bloqueaba para siempre (todo el form colgado).
            dataType: 'json',
            timeout: 30000,
            success: function (data) {
                if (data.success) {
                    switch (action) {
                        case 'add':
                            if (save) {
                                if (typeof data.value === 'object') {
                                    for (const prop in data.value) {
                                        sessionStorage.setItem(prop, data.value[prop]);
                                    }
                                } else {
                                    sessionStorage.setItem(name, data.value);
                                }
                            }
                            resolve(data);
                            break;
                        case 'delete':
                            sessionStorage.removeItem(name);
                            resolve(data);
                            break;
                        case 'clear':
                            // Esperar a clear_session (que restaura enable_analytics con el valor real)
                            // antes de resolver, para que ningún caller continúe/redirija antes de la restauración.
                            clear_session(analytics_var).then(
                                clear_session_resolve => {
                                    resolve(data);
                                }
                            )
                            break;
                        default:
                            resolve(data);
                    }
                } else {
                    // Respuesta JSON válida con success:false (p.ej. sesión inválida): no dejar
                    // la promesa colgada, la cola debe continuar.
                    resolve({ success: false });
                }
            },
            error: function (error) {
                resolve({ success: false });
            }
        });
    });

    // Serializar: este write espera a que termine el anterior. `enqueue = false` lo usa SOLO
    // clear_session para su write interno (evita la espera circular en la acción 'clear':
    // clear → clear_session → setSessionVar → esperar al propio clear).
    const result = enqueue ? sessionWriteQueue.then(write) : write();
    if (enqueue) sessionWriteQueue = result.catch(() => {}); // la cola nunca se rompe si un write falla
    return result;
};


export let checkSessionVar = (variable) => new Promise ((resolve, reject) => {
    $.ajax ({
        url: location.origin + `/config/check_session_var`,
        data: {
            variable: variable
        },
        type: 'GET',
        // FIX (2026-08-11): dataType 'json' + timeout + error que resuelve. Antes, una respuesta
        // HTML (redirección a /offline.html) o un error dejaban la promesa colgada para siempre.
        dataType: 'json',
        timeout: 30000,
        success: async function (data) {
            resolve ({success: data.success});
        },
        error: function (error) {
            console.error('checkSessionVar error:', error);
            resolve ({success: false});
        }
    });

    return false;
})

export let checkSessionVarWithData = (variable) => new Promise ((resolve, reject) => {

    $.ajax ({
        url: location.origin + `/config/check_session_var`,
        data: {
            variable: variable
        },
        type: 'GET',
        // FIX (2026-08-11): dataType 'json' + timeout + error que resuelve (ver checkSessionVar).
        dataType: 'json',
        timeout: 30000,
        success: async function (data) {
            if (data.success) {
                resolve (data);
            } else {
                if (data.data) {
                    await sessionStorage.removeItem (data.data);
                }
                resolve (data);
            }
        },
        error: function (error) {
            console.error('checkSessionVarWithData error:', error);
            resolve ({success: false, data: null});
        }
    });

    return false;
})

export let clear_session = (analytic = false) => new Promise ((resolve, reject) => {

    sessionStorage.clear ();

    setSessionVar('enable_analytics', analytic, 'add', false, true, 0, false).then(
        analytics_session => {
            set_locale ().then (
                locale => {
                    resolve ({
                        success: true,
                        analytic: analytics_session,
                        locale: locale
                    })
                }
            )
        }
    );


})


export default class extends Controller {


}